import React, { FC, useMemo } from 'react'
import Avatar from 'react-avatar'
import ReactTimeAgo from 'react-time-ago'
import { SvgIcon } from 'src/components/shared/SvgIcon'
import { SvgType } from 'src/components/shared/SvgIcon/SvgIcon'
import { MessageType } from '../LiveQuestions'
import { AuditoriumMessageStyle } from './styled'

interface AuditoriumQuestionCardProps {
  message: MessageType
}

export const AuditoriumQuestionCard: FC<AuditoriumQuestionCardProps> = ({ message }) => {
  return useMemo(() => {
    return (
      <AuditoriumMessageStyle featured={message.featured}>
        <div className="mb-2">
          <div className="d-flex align-items-center">
            <div className="profile">
              <Avatar name={message.dbUser} size="30" round />
            </div>
            <div className="sender">
              <div className="name">{message.dbUser.toLowerCase()}</div>
              <small className="d-block timestamp">{message.dbTimestamp && <ReactTimeAgo date={message.dbTimestamp} />}</small>
            </div>
          </div>
          {!message.archived && <p className="message">{message.dbMessage}</p>}
        </div>
        <div className="review-container">{message?.featured && <SvgIcon type={SvgType.STAR_FILLED} fill={'#ff9e1a'} />}</div>
      </AuditoriumMessageStyle>
    )
  }, [message])
}

export default AuditoriumQuestionCard
